import { styled } from "../../theme";

interface ColumnContainerProps {
  reverse?: boolean;
}
export const Container = styled.div`
  max-width: 100%;
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  /* justify-content: center; */
  max-height: 90%;
  height: 90%;
`;
export const ColumnContainer = styled.div<ColumnContainerProps>`
  display: flex;
  flex-direction: ${({ reverse }) => (reverse ? "row-reverse" : "row")};
  align-items: center;
  flex-wrap: wrap;
  justify-content: center;
  max-height: 90%;
  .rich-text-container {
    font-size: 1.15em;
    height: 100%;
    @media (max-width: ${({ theme }) => theme.mobileFirst.breakPoint}) {
      font-size: 1em;
    }
    @media (max-width: ${({ theme }) => theme.notebook.breakPoint}) {
      font-size: 0.8em;
    }
  }
  @media (max-width: ${({ theme }) => theme.mobileFirst.breakPoint}) {
    flex-direction: ${({ reverse }) => (reverse ? "column-reverse" : "column")};
    .navigation-column {
      order: ${({ reverse }) => (reverse ? 1 : 3)};
    }
    .multimedia-richetext-column {
      order: ${({ reverse }) => (reverse ? 2 : 1)};
    }
    .multimedia-media-column {
      order: ${({ reverse }) => (reverse ? 3 : 2)};
    }
  }
`;

export const Column = styled.div`
  width: 40%;
  max-width: 40%;
  min-width: 40%;
  max-height: 100%;
  height: 100%;
  padding: 1em;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  &.multimedia-richetext-column {
    width: 60%;
    max-width: 60%;
    min-width: 60%;
    justify-content: flex-start;
    padding: 1.5em;
    box-sizing: border-box;
  }
  @media (max-width: ${({ theme }) => theme.mobileFirst.breakPoint}) {
    width: 100%;
    max-width: 100%;
    min-width: 100%;
    &.multimedia-richetext-column {
      width: 100%;
      max-width: 100%;
      min-width: 100%;
    }
  }
`;
export const ButtonContainer = styled.div`
margin-top:1em;`;

export const MultimediaTitleContainer = styled.div`
  min-height: 10%;
  align-self: flex-start;
  padding-top: 1em;
  .title_level_2 {
    text-transform: uppercase;
    color: ${({ theme }) => theme.color.primary};
    text-align: left;
    padding-left: 2em;
    padding-bottom: 0.2em;
    border-bottom: 0.2em ${({ theme }) => theme.color.primary} solid;
    @media (max-width: ${({ theme }) => theme.mobileFirst.breakPoint}) {
      padding-left: 1em;
    }
  }
  @media (max-width: ${({ theme }) => theme.mobileFirst.breakPoint}) {
    min-height: 3em;
    position: relative;
    font-size: 0.9em;
    padding-top: 5em;
    padding-bottom: 2em;
    max-width: 90%;
  }
`;
